interface AskPrybarOptions {
  toolCallHint?: { name: string; args?: Record<string, unknown> };
  directExec?: boolean;
}

// Open the command bar pre-asking a question (the SDK listens for this event).
export function askPrybar(message: string, options: AskPrybarOptions = {}): void {
  window.dispatchEvent(new CustomEvent("prybar:ask", { detail: { message, ...options } }));
}

export function openFeedbackSurvey(route = currentRoute()): void {
  askPrybar("Open feedback.", {
    directExec: true,
    toolCallHint: {
      name: "survey.picker",
      args: { route },
    },
  });
}

/**
 * "Why this?" on an attention card. The decision is required, not optional:
 * without it the answer is about the latest tick, which is a different
 * decision from the card in front of them. A member looking at a nudge was
 * told "I stayed quiet, no rule fired". The caller hides the control rather
 * than calling this with nothing.
 */
export function askWhyThis(decisionId: string): void {
  askPrybar("Why am I seeing this?", {
    toolCallHint: { name: "heartbeat.why", args: { decisionId } },
  });
}

function currentRoute(): string {
  return typeof window === "undefined" ? "/" : window.location.pathname;
}

// Open the command bar empty, from a docked trigger. Decouples the trigger's
// placement (sidebar, mobile header) from the bar itself.
export function openPrybar(): void {
  window.dispatchEvent(new CustomEvent("prybar:open"));
}
